import { useContext } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { UserProfileContext } from "../contexts/UserProfileStepsContext";
import {
  addEducationValidation,
  checkTimeGreaterThanCurrentDate,
} from "../shared/const.prop";

const AddCollegeInfo = () => {
  const userContext = useContext(UserProfileContext);
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({
    defaultValues: {
      collegeInfo: userContext.college ?? [
        { college: "", className: "", startYear: "", endYear: "" },
      ],
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "collegeInfo",
  });
  const submitHandler = (data) => {
    userContext.updateUserInfo("updateUserInfo", data.collegeInfo, "college");
  };
  return (
    <>
      <form onSubmit={handleSubmit(submitHandler)}>
        <div className="">
          {fields.map((item, index) => {
            return (
              <div className="form-content" key={item.id}>
                <div className="row mt-5 mb-4">
                  <div className="col-md-2"></div>
                  <div className="col-md-4">
                    <div className="form-group input-group">
                      <span className="input-group-addon addon-icon py-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                        >
                          <path
                            d="M3.0625 1.75V11.375H10.9375V1.75H3.0625ZM2.625 0.875H11.375C11.491 0.875 11.6023 0.921094 11.6844 1.00314C11.7664 1.08519 11.8125 1.19647 11.8125 1.3125V11.8125C11.8125 11.9285 11.7664 12.0398 11.6844 12.1219C11.6023 12.2039 11.491 12.25 11.375 12.25H2.625C2.50897 12.25 2.39769 12.2039 2.31564 12.1219C2.23359 12.0398 2.1875 11.9285 2.1875 11.8125V1.3125C2.1875 1.19647 2.23359 1.08519 2.31564 1.00314C2.39769 0.921094 2.50897 0.875 2.625 0.875Z"
                            fill="#000842"
                          />
                          <path
                            d="M0.875 11.375H13.125V12.25H0.875V11.375ZM4.375 2.625H6.125V3.9375H4.375V2.625Z"
                            fill="#000842"
                          />
                          <path
                            d="M5.25 11.375H8.75V10.5C8.75 10.0359 8.56563 9.59075 8.23744 9.26256C7.90925 8.93437 7.46413 8.75 7 8.75C6.53587 8.75 6.09075 8.93437 5.76256 9.26256C5.43437 9.59075 5.25 10.0359 5.25 10.5V11.375ZM7 7.875C7.69619 7.875 8.36387 8.15156 8.85616 8.64384C9.34844 9.13613 9.625 9.80381 9.625 10.5V12.25H4.375V10.5C4.375 9.80381 4.65156 9.13613 5.14384 8.64384C5.63613 8.15156 6.30381 7.875 7 7.875ZM4.375 5.25H6.125V6.5625H4.375V5.25ZM7.875 2.625H9.625V3.9375H7.875V2.625ZM7.875 5.25H9.625V6.5625H7.875V5.25Z"
                            fill="#000842"
                          />
                        </svg>
                      </span>
                      <label className="has-float-label">
                        <input
                          className="form-control  form py-4"
                          type="text"
                          {...register(
                            `collegeInfo.${index}.college`,
                            addEducationValidation.college
                          )}
                        />
                        <span>
                          College
                          {/* <span className="text-danger">*</span> */}
                        </span>
                      </label>
                    </div>

                    {errors?.collegeInfo?.[index]?.college && (
                      <p className="field-error">College Name is required</p>
                    )}
                  </div>
                  <div className="col-md-4">
                    <div className="form-group input-group">
                      <span className="input-group-addon addon-icon py-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M2 2H12.3333V3.66667H11.6667V2.66667H2.66667V10.3333H9.79567V11H2V2ZM12 6.33333C12.2652 6.33333 12.5196 6.22798 12.7071 6.04044C12.8946 5.8529 13 5.59855 13 5.33333C13 5.06812 12.8946 4.81376 12.7071 4.62623C12.5196 4.43869 12.2652 4.33333 12 4.33333C11.7348 4.33333 11.4804 4.43869 11.2929 4.62623C11.1054 4.81376 11 5.06812 11 5.33333C11 5.59855 11.1054 5.8529 11.2929 6.04044C11.4804 6.22798 11.7348 6.33333 12 6.33333ZM12.677 7.00333C13.11 7.00333 13.4527 7.198 13.677 7.49867C13.8867 7.78033 13.9753 8.12867 13.9953 8.45033C14.0149 8.7803 13.97 9.11091 13.863 9.42367C13.763 9.71367 13.594 10.0137 13.3333 10.2193V13.5C13.3336 13.6256 13.2865 13.7467 13.2015 13.8392C13.1165 13.9318 12.9998 13.9889 12.8746 13.9993C12.7494 14.0096 12.6249 13.9725 12.5259 13.8952C12.4268 13.818 12.3604 13.7063 12.34 13.5823L11.91 11H11.8107L11.3247 13.592C11.3016 13.7143 11.2337 13.8237 11.1343 13.8986C11.0349 13.9735 10.9111 14.0087 10.7871 13.9972C10.6632 13.9857 10.548 13.9283 10.464 13.8364C10.3801 13.7444 10.3335 13.6245 10.3333 13.5V8.74433C10.2667 8.84587 10.2009 8.94799 10.136 9.05067L10.11 9.09167L10.1033 9.10233L10.1017 9.10533C10.0567 9.17747 9.99417 9.23696 9.91987 9.27819C9.84557 9.31943 9.76198 9.34104 9.677 9.341H8.01033C7.87773 9.341 7.75055 9.28832 7.65678 9.19455C7.56301 9.10079 7.51033 8.97361 7.51033 8.841C7.51033 8.70839 7.56301 8.58121 7.65678 8.48745C7.75055 8.39368 7.87773 8.341 8.01033 8.341H9.40267C9.48367 8.21567 9.59033 8.053 9.70233 7.88967C9.819 7.71933 9.94767 7.539 10.0623 7.39767C10.118 7.32867 10.1803 7.25667 10.243 7.19767C10.2737 7.16867 10.3163 7.131 10.3683 7.09767C10.4601 7.03743 10.5672 7.00481 10.677 7.00367L12.677 7.00333Z"
                            fill="#000842"
                          />
                        </svg>
                      </span>
                      <label className="has-float-label">
                        <input
                          className="form-control form py-4"
                          type="text"
                          {...register(
                            `collegeInfo.${index}.className`,
                            addEducationValidation.className
                          )}
                        />
                        <span>
                          Qualification
                          {/* <span className="text-danger">*</span> */}
                        </span>
                      </label>
                    </div>

                    {errors?.collegeInfo?.[index]?.className && (
                      <p className="field-error">className Name is required</p>
                    )}
                  </div>
                  <div className="col-md-2"></div>
                </div>
                <div className="row">
                  <div className="col-md-2"></div>
                  <div className="col-md-4">
                    <div className="form-group input-group">
                      <span className="input-group-addon addon-icon py-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.5292 0.666664C10.8052 0.666664 11.0292 0.890664 11.0292 1.16666L11.0295 1.73187C12.0029 1.79861 12.8113 2.13203 13.3835 2.7054C14.0082 3.33273 14.3368 4.23473 14.3335 5.31673V11.3987C14.3335 13.6201 12.9228 15.0001 10.6528 15.0001H5.01416C2.74416 15.0001 1.3335 13.6007 1.3335 11.3481V5.3154C1.3335 3.22019 2.59153 1.87529 4.64329 1.7321L4.6437 1.16666C4.6437 0.890664 4.8677 0.666664 5.1437 0.666664C5.4197 0.666664 5.6437 0.890664 5.6437 1.16666L5.6435 1.71933H10.0288L10.0292 1.16666C10.0292 0.890664 10.2532 0.666664 10.5292 0.666664ZM13.3335 6.60266H2.3335V11.3481C2.3335 13.0587 3.2855 14.0001 5.01416 14.0001H10.6528C12.3815 14.0001 13.3335 13.0761 13.3335 11.3987L13.3335 6.60266ZM10.801 10.7975C11.077 10.7975 11.301 11.0215 11.301 11.2975C11.301 11.5735 11.077 11.7975 10.801 11.7975C10.525 11.7975 10.2983 11.5735 10.2983 11.2975C10.2983 11.0215 10.519 10.7975 10.795 10.7975H10.801ZM7.84263 10.7975C8.11863 10.7975 8.34263 11.0215 8.34263 11.2975C8.34263 11.5735 8.11863 11.7975 7.84263 11.7975C7.56663 11.7975 7.33996 11.5735 7.33996 11.2975C7.33996 11.0215 7.56063 10.7975 7.83663 10.7975H7.84263ZM4.8781 10.7975C5.1541 10.7975 5.3781 11.0215 5.3781 11.2975C5.3781 11.5735 5.1541 11.7975 4.8781 11.7975C4.6021 11.7975 4.37476 11.5735 4.37476 11.2975C4.37476 11.0215 4.5961 10.7975 4.8721 10.7975H4.8781ZM10.801 8.2064C11.077 8.2064 11.301 8.4304 11.301 8.7064C11.301 8.9824 11.077 9.2064 10.801 9.2064C10.525 9.2064 10.2983 8.9824 10.2983 8.7064C10.2983 8.4304 10.519 8.2064 10.795 8.2064H10.801ZM7.84263 8.2064C8.11863 8.2064 8.34263 8.4304 8.34263 8.7064C8.34263 8.9824 8.11863 9.2064 7.84263 9.2064C7.56663 9.2064 7.33996 8.9824 7.33996 8.7064C7.33996 8.4304 7.56063 8.2064 7.83663 8.2064H7.84263ZM4.8781 8.2064C5.1541 8.2064 5.3781 8.4304 5.3781 8.7064C5.3781 8.9824 5.1541 9.2064 4.8781 9.2064C4.6021 9.2064 4.37476 8.9824 4.37476 8.7064C4.37476 8.4304 4.5961 8.2064 4.8721 8.2064H4.8781ZM10.0288 2.71933H5.6435L5.6437 3.36066C5.6437 3.63666 5.4197 3.86066 5.1437 3.86066C4.8677 3.86066 4.6437 3.63666 4.6437 3.36066L4.64334 2.73447C3.14985 2.85993 2.3335 3.76523 2.3335 5.3154V5.60266H13.3335L13.3335 5.3154C13.3362 4.49206 13.1148 3.85206 12.6755 3.41206C12.2898 3.02527 11.7261 2.79426 11.0297 2.73479L11.0292 3.36066C11.0292 3.63666 10.8052 3.86066 10.5292 3.86066C10.2532 3.86066 10.0292 3.63666 10.0292 3.36066L10.0288 2.71933Z"
                            fill="#000842"
                          />
                        </svg>
                      </span>
                      <label className="has-float-label">
                        <input
                          className="form-control  form py-4"
                          type="date"
                          {...register(
                            `collegeInfo.${index}.startYear`,
                            addEducationValidation.startYear
                          )}
                        />
                        <span>
                          Start year
                          {/* <span className="text-danger">*</span> */}
                        </span>
                      </label>
                    </div>

                    {errors?.collegeInfo?.[index]?.startYear && (
                      <p className="field-error">
                        {errors?.collegeInfo?.[index]?.startYear.message}
                      </p>
                    )}
                  </div>
                  <div className="col-md-4">
                    <div className="form-group input-group">
                      <span className="input-group-addon addon-icon py-1">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 16 16"
                          fill="none"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10.5292 0.666664C10.8052 0.666664 11.0292 0.890664 11.0292 1.16666L11.0295 1.73187C12.0029 1.79861 12.8113 2.13203 13.3835 2.7054C14.0082 3.33273 14.3368 4.23473 14.3335 5.31673V11.3987C14.3335 13.6201 12.9228 15.0001 10.6528 15.0001H5.01416C2.74416 15.0001 1.3335 13.6007 1.3335 11.3481V5.3154C1.3335 3.22019 2.59153 1.87529 4.64329 1.7321L4.6437 1.16666C4.6437 0.890664 4.8677 0.666664 5.1437 0.666664C5.4197 0.666664 5.6437 0.890664 5.6437 1.16666L5.6435 1.71933H10.0288L10.0292 1.16666C10.0292 0.890664 10.2532 0.666664 10.5292 0.666664ZM13.3335 6.60266H2.3335V11.3481C2.3335 13.0587 3.2855 14.0001 5.01416 14.0001H10.6528C12.3815 14.0001 13.3335 13.0761 13.3335 11.3987L13.3335 6.60266ZM10.801 10.7975C11.077 10.7975 11.301 11.0215 11.301 11.2975C11.301 11.5735 11.077 11.7975 10.801 11.7975C10.525 11.7975 10.2983 11.5735 10.2983 11.2975C10.2983 11.0215 10.519 10.7975 10.795 10.7975H10.801ZM7.84263 10.7975C8.11863 10.7975 8.34263 11.0215 8.34263 11.2975C8.34263 11.5735 8.11863 11.7975 7.84263 11.7975C7.56663 11.7975 7.33996 11.5735 7.33996 11.2975C7.33996 11.0215 7.56063 10.7975 7.83663 10.7975H7.84263ZM4.8781 10.7975C5.1541 10.7975 5.3781 11.0215 5.3781 11.2975C5.3781 11.5735 5.1541 11.7975 4.8781 11.7975C4.6021 11.7975 4.37476 11.5735 4.37476 11.2975C4.37476 11.0215 4.5961 10.7975 4.8721 10.7975H4.8781ZM10.801 8.2064C11.077 8.2064 11.301 8.4304 11.301 8.7064C11.301 8.9824 11.077 9.2064 10.801 9.2064C10.525 9.2064 10.2983 8.9824 10.2983 8.7064C10.2983 8.4304 10.519 8.2064 10.795 8.2064H10.801ZM7.84263 8.2064C8.11863 8.2064 8.34263 8.4304 8.34263 8.7064C8.34263 8.9824 8.11863 9.2064 7.84263 9.2064C7.56663 9.2064 7.33996 8.9824 7.33996 8.7064C7.33996 8.4304 7.56063 8.2064 7.83663 8.2064H7.84263ZM4.8781 8.2064C5.1541 8.2064 5.3781 8.4304 5.3781 8.7064C5.3781 8.9824 5.1541 9.2064 4.8781 9.2064C4.6021 9.2064 4.37476 8.9824 4.37476 8.7064C4.37476 8.4304 4.5961 8.2064 4.8721 8.2064H4.8781ZM10.0288 2.71933H5.6435L5.6437 3.36066C5.6437 3.63666 5.4197 3.86066 5.1437 3.86066C4.8677 3.86066 4.6437 3.63666 4.6437 3.36066L4.64334 2.73447C3.14985 2.85993 2.3335 3.76523 2.3335 5.3154V5.60266H13.3335L13.3335 5.3154C13.3362 4.49206 13.1148 3.85206 12.6755 3.41206C12.2898 3.02527 11.7261 2.79426 11.0297 2.73479L11.0292 3.36066C11.0292 3.63666 10.8052 3.86066 10.5292 3.86066C10.2532 3.86066 10.0292 3.63666 10.0292 3.36066L10.0288 2.71933Z"
                            fill="#000842"
                          />
                        </svg>
                      </span>
                      <label className="has-float-label">
                        <input
                          className="form-control  form py-4"
                          type="date"
                          {...register(`collegeInfo.${index}.endYear`, {
                            validate: (date) => {
                              if (
                                checkTimeGreaterThanCurrentDate({
                                  type: "future",
                                  date,
                                })
                              )
                                return "Enter valid date";
                              const startDate =
                                getValues("collegeInfo")[index].startYear;

                              if (
                                startDate &&
                                checkTimeGreaterThanCurrentDate({
                                  type: "compare",
                                  startDate,
                                  endDate: date,
                                })
                              )
                                return "Enter valid start and end date";
                              if (startDate && date) {
                                const oneMonthInMillis =
                                  30 * 24 * 60 * 60 * 1000; // Milliseconds in one month
                                const duration =
                                  new Date(date).getTime() -
                                  new Date(startDate).getTime();
                                const isDurationValid =
                                  duration >= oneMonthInMillis;
                                if (!isDurationValid)
                                  return "One month course is required";
                              }
                              return null;
                            },
                          })}
                        />
                        <span>
                          End year
                          {/* <span className="text-danger">*</span> */}
                        </span>
                      </label>
                    </div>

                    {errors?.collegeInfo?.[index]?.endYear?.message && (
                      <p className="field-error">
                        {errors?.collegeInfo?.[index]?.endYear?.message}
                      </p>
                    )}
                  </div>
                  <div className="col-md-1 col-12 mt-1 text-right">
                    {index > 0 && (
                      <span
                        onClick={() => remove(index)}
                        className="cursor-pointer delete-field-btn rounded pad-10 text-center"
                        title="Delete College Details"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="22"
                          height="22"
                          viewBox="0 0 25 24"
                          fill="none"
                        >
                          <path
                            d="M19.0028 8.7332C19.3959 8.7662 19.6885 9.11919 19.6563 9.52219C19.6514 9.58919 19.1218 16.3141 18.8165 19.135C18.6292 20.875 17.5066 21.932 15.8154 21.963C14.5299 21.987 14.2187 22 12.9322 22C12.6884 22 12.4456 22 12.2017 21.999C11.8077 21.997 11.4887 21.669 11.4907 21.264C11.4917 20.861 11.8106 20.536 12.2046 20.536L12.5671 20.5369C13.0237 20.5376 13.3902 20.5363 13.7387 20.5332L14.2569 20.5272C14.6925 20.5211 15.1563 20.5123 15.789 20.501C16.7634 20.482 17.2891 19.983 17.3974 18.975C17.7007 16.1741 18.2294 9.47119 18.2342 9.40419C18.2654 9.00119 18.6146 8.7122 19.0028 8.7332ZM5.01947 8.7329C5.41253 8.7149 5.75683 9.00189 5.78804 9.40489C5.79292 9.47189 6.31765 16.1568 6.62391 18.9797C6.73022 19.9667 7.24911 20.4767 8.16593 20.4967C8.55997 20.5047 8.87306 20.8397 8.86525 21.2437C8.85648 21.6427 8.53851 21.9597 8.1513 21.9597H8.13667C6.51174 21.9247 5.38912 20.8457 5.20478 19.1427C4.89657 16.2968 4.37086 9.58889 4.36599 9.52089C4.3338 9.11889 4.6264 8.7659 5.01947 8.7329ZM14.0795 2C14.967 2 15.7473 2.61399 15.9775 3.49398C16.0799 3.88497 15.8536 4.28597 15.4732 4.39096C15.0938 4.49596 14.7017 4.26397 14.5993 3.87297C14.5359 3.63198 14.3223 3.46398 14.0795 3.46398H9.94301C9.70015 3.46398 9.48655 3.63198 9.42315 3.87297L9.1959 5.04595C9.16468 5.20395 9.11592 5.35195 9.0574 5.49695H20.2973C20.6913 5.49695 21.0112 5.82394 21.0112 6.22794C21.0112 6.63293 20.6913 6.95993 20.2973 6.95993H3.72421C3.33017 6.95993 3.01123 6.63293 3.01123 6.22794C3.01123 5.82394 3.33017 5.49695 3.72421 5.49695H6.91846C7.34371 5.49695 7.71337 5.18595 7.79628 4.75996L8.03426 3.53998C8.27517 2.61399 9.05545 2 9.94301 2H14.0795Z"
                            fill="#fff"
                          />
                        </svg>
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
        {fields.length < 4 && (
          <div className="row">
            <div className="col-md-4"></div>
            <div className="col-md-4">
              <div className="justify-content-center">
                <button
                  type="button"
                  onClick={() =>
                    append({
                      college: "",
                      className: "",
                      startDate: "",
                      endDate: "",
                    })
                  }
                  className="btn btn-secondary btn-block sec-btn py-2 mt-5"
                >
                  Add
                </button>
              </div>
            </div>
            <div className="col-md-4"></div>
          </div>
        )}
        <div className="row">
          <div className="col-md-4"></div>
          <div className="col-md-4">
            <div className="justify-content-center">
              <button
                type="submit"
                className="btn btn-primary btn-block sign-btn mt-5"
              >
                Continue
              </button>
            </div>
          </div>
          <div className="col-md-4"></div>
        </div>
      </form>
    </>
  );
};

export default AddCollegeInfo;
